import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { supportRequest, supportError, supportDate } from '../components/support/supportApi';
import '../components/support/support.css';

export default function AnnouncementPage() {
  const { notificationId } = useParams(); const navigate = useNavigate();
  const [notice, setNotice] = useState(null), [error, setError] = useState(''), [retry, setRetry] = useState(0);
  useEffect(() => {
    let live = true; setNotice(null); setError('');
    supportRequest(`/support/announcements/${encodeURIComponent(notificationId)}`).then(data => {
      if (live) setNotice(data);
      supportRequest(`/notifications/${encodeURIComponent(notificationId)}/read`, { method: 'POST' }).catch(() => {});
    }).catch(err => { if (live) setError(supportError(err)); });
    return () => { live = false; };
  }, [notificationId, retry]);
  return <main className="support-workspace max-w-3xl mx-auto p-6" data-testid="admin-announcement-page"><p className="support-meta">PAR SEEKER ADMIN</p>
    {notice && <><h1 className="text-3xl sm:text-4xl font-bold my-4" data-testid="announcement-title">{notice.title}</h1><p className="support-meta" data-testid="announcement-date">{supportDate(notice.created_at)}</p><p className="support-announcement-body my-8" data-testid="announcement-body">{notice.message}</p></>}
    {!notice && !error && <p data-testid="announcement-loading">Loading message…</p>}
    {error && <p className="support-error" role="alert" data-testid="announcement-error">{error}<Button variant="ghost" onClick={() => setRetry(v => v + 1)} data-testid="announcement-retry">Retry</Button></p>}
    <Button variant="outline" onClick={() => navigate('/support')} data-testid="announcement-contact-admin">Contact Admin</Button>
  </main>;
}